import React from 'react'
import { injectIntl } from 'react-intl'
import { ReactComponent as NoResults } from 'assets/img/management-ui-no-results.svg'
import messages from '../translate'

function NoDataScreen({
  intl: { formatMessage },
  onClearFilter,
  isUpdating,
  specialNoResultScreen,
}) {
  if (isUpdating) {
    return null
  }

  return (
    <div className="management-ui-no-jobs">
      {specialNoResultScreen || (
        <>
          <NoResults className="no-jobs-image" />
          <div className="no-jobs-title">
            {formatMessage(messages.noResultsMessage)}
          </div>
          <div>
            <div className="no-jobs-subtitle">
              {formatMessage(messages.filterAppliedResultsHidden)}
            </div>
            <span className="clear-filter" onClick={onClearFilter}>
              {formatMessage(messages.clearFilter)}
            </span>
          </div>
        </>
      )}
    </div>
  )
}

export default injectIntl(NoDataScreen)
